// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/boundary-layer.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/boundary-layer/boundary-layer.js';

mount([g0]);
